/* eslint-disable @typescript-eslint/no-explicit-any */
import { Collection, CollectionQuery } from "../../../models/collection.model"
import { ManagementFeeIncrease } from "../../../models/management-fee-increase.model"
import { notification } from "../../../shared/component/notification/utility/notification"
import { collectionQueryBuilder } from "../../../shared/utility/collection-builder/collection-query-builder"
import { appApi } from "../../../store/app.api"
import { LEASE_ENDPOINT } from "../lease.endpoint"

let leaseCollection: CollectionQuery
let leaseCountCollection: CollectionQuery
let ownersOfLeaseCollection: CollectionQuery
let propertiesOfLeaseCollection: CollectionQuery
let tenantsOfLeaseCollection: CollectionQuery
let unitsOfLeaseCollection: CollectionQuery
let archivedLeaseCollection: CollectionQuery

let managementFeeIncreaseCollection: CollectionQuery
let archivedManagementFeeIncreaseCollection: CollectionQuery
const managementFeeIncreaseQuery = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getManagementFeeIncrease: builder.query<ManagementFeeIncrease, string>({
      query: (id: string) => ({
        url: `${LEASE_ENDPOINT.detailManagementFeeIncrease}/${id}`,
        method: "get",
      }),
      providesTags: ["Rent Increase"],
    }),

    getManagementFeeIncreases: builder.query<Collection<ManagementFeeIncrease>, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${LEASE_ENDPOINT.listManagementFeeIncrease}`,
        method: "GET",
        params: collectionQueryBuilder(data),
      }),
      providesTags: ["Rent Increases"],
      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // if (data) {
          //   managementFeeIncreaseCollection = param
          // }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    createManagementFeeIncrease: builder.mutation<ManagementFeeIncrease, ManagementFeeIncrease>({
      query: (newData: any) => ({
        url: `${LEASE_ENDPOINT.createManagementFeeIncrease}`,
        method: "post",
        data: newData,
        permissions: "manage-leases",
      }),
      invalidatesTags: ["Rent Increases"],
      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully created")
            // dispatch(
            //   managementFeeIncreaseQuery.util.updateQueryData(
            //     "getManagementFeeIncreases",
            //     managementFeeIncreaseCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data.unshift(data)
            //         draft.count += 1
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),
    createBulkManagementFeeIncrease: builder.mutation<ManagementFeeIncrease, any>({
      query: (newData: any) => ({
        url: `${LEASE_ENDPOINT.createBulkManagementFeeIncrease}`,
        method: "post",
        data: newData,
        permissions: "manage-leases",
      }),
      invalidatesTags: ["Rent Increases"],
      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully created")
            // dispatch(
            //   managementFeeIncreaseQuery.util.updateQueryData(
            //     "getManagementFeeIncreases",
            //     managementFeeIncreaseCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data.unshift(data)
            //         draft.count += 1
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    updateManagementFeeIncrease: builder.mutation<ManagementFeeIncrease, ManagementFeeIncrease>({
      query: (newData: any) => ({
        url: `${LEASE_ENDPOINT.updateManagementFeeIncrease}`,
        method: "put",
        data: newData,
        permission: "manage-leases",
      }),
      invalidatesTags: ["Rent Increases", "Rent Increase"],

      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully updated")
            // dispatch(
            //   managementFeeIncreaseQuery.util.updateQueryData(
            //     "getManagementFeeIncreases",
            //     managementFeeIncreaseCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft?.data?.map((lease) => {
            //           if (lease.id === data.id) return data
            //           else {
            //             return lease
            //           }
            //         })
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),
    changeManagementFeeIncreaseStatus: builder.mutation<
      ManagementFeeIncrease,
      { id: string; status: string }
    >({
      query: (newData: { id: string; status: string }) => ({
        url: `${LEASE_ENDPOINT.updateManagementFeeIncrease}`,
        method: "post",
        data: newData,
        permission: "manage-leases",
      }),
      invalidatesTags: ["Rent Increases"],

      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully updated")
            // dispatch(
            //   managementFeeIncreaseQuery.util.updateQueryData(
            //     "getManagementFeeIncreases",
            //     managementFeeIncreaseCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft?.data?.map((lease) => {
            //           if (lease.id === data.id) return data
            //           else {
            //             return lease
            //           }
            //         })
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    deleteManagementFeeIncrease: builder.mutation<boolean, string>({
      query: (id: string) => ({
        url: `${LEASE_ENDPOINT.deleteManagementFeeIncrease}/${id}`,
        method: "delete",
        permission: "manage-leases",
      }),
      invalidatesTags: ["Rent Increases"],

      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully deleted")
            // dispatch(
            //   managementFeeIncreaseQuery.util.updateQueryData(
            //     "getManagementFeeIncreases",
            //     managementFeeIncreaseCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft.data.filter(
            //           (managementFeeIncrease) => managementFeeIncrease.id !== id,
            //         )
            //         draft.count -= 1
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),
    
  }),
  overrideExisting: true,
})
export const {
  useLazyGetManagementFeeIncreaseQuery,
  useLazyGetManagementFeeIncreasesQuery,
  useUpdateManagementFeeIncreaseMutation,
  useCreateManagementFeeIncreaseMutation,
  useDeleteManagementFeeIncreaseMutation,
  useChangeManagementFeeIncreaseStatusMutation,
  useCreateBulkManagementFeeIncreaseMutation
} = managementFeeIncreaseQuery
